import { useApi } from '@/api';
import filtredMetricIsNotAvailable from '../../views/Dashboard/helper/filtredMetricIsNotAvailable';

import {
  GET_DASHBOARDS,
  GET_DASHBOARDS_TEMPLATES,
  EDIT_MODE,
  SET_DASHBOARD_FILTER,
  ADD_DASHBOARD_IS_LOADING,
  GET_DASHBOARD_BY_ID,
} from '../action_types/dashboards';
import type { GetDashboardsByIdResponse, GetDashboardsData, GetDashboardsResponse } from '@/types/openapi-ts';
import type { ActionContext } from 'vuex';
import { useTypedStore, type RootState } from '..';
import type { TypedStoreModule } from '@/types/vuex';

export interface DashboardsState {
  dashboards: GetDashboardsResponse['payload'],
  dashboardById: GetDashboardsByIdResponse['payload'],
  templates: any[],
  editMode: boolean,
  saveEditModePath: any,
  stateDashboardFilter: any,
  addDashbordIsLoading: boolean,
}

const stateData: () => DashboardsState = () => ({
  dashboards: [],
  //@ts-expect-error инициализация без проверки типа
  dashboardById: {},
  templates: [],
  editMode: false,
  saveEditModePath: {},
  stateDashboardFilter: {},
  addDashbordIsLoading: false,
});

const getters = {
  overviewDashboard(state: DashboardsState) {
    const store = useTypedStore();
    const availebleColumns = (
      store.getters['reports/reportsSettings'].metrics || []
    ).map((metric) => metric.column_name);
    const availebleDimensions = (
      store.getters['reports/reportsSettings'].dimensions || []
    ).map((metric) => metric.column_name);
    const findOverview = state.dashboards.filter((board) => board.is_default);
    return filtredMetricIsNotAvailable(findOverview, availebleColumns, availebleDimensions).length
      ? filtredMetricIsNotAvailable(findOverview, availebleColumns, availebleDimensions)
      : filtredMetricIsNotAvailable(state.templates, availebleColumns, availebleDimensions);
    // const result = state.dashboards.filter(board => board.is_default);
    // return result;
  },

  dashboards: (state: DashboardsState) => {
    const store = useTypedStore();

    const availebleColumns = (
      store.getters['reports/reportsSettings'].metrics || []
    ).map((metric) => metric.column_name);
    const availebleDimensions = (
      store.getters['reports/reportsSettings'].dimensions || []
    ).map((metric) => metric.column_name);

    const result = filtredMetricIsNotAvailable(
      state.dashboards,
      availebleColumns,
      availebleDimensions,
    ).filter((dash) => !dash.is_default);

    // // const result = state.dashboards.filter(dash => !dash.is_default);
    // console.log(result, 'result');
    return result;
  },

  dashboardById(state: DashboardsState) {
    const store = useTypedStore();

    const availebleColumns = (
      store.getters['reports/reportsSettings'].metrics || []
    ).map((metric) => metric.column_name);
    const availebleDimensions = (
      store.getters['reports/reportsSettings'].dimensions || []
    ).map((metric) => metric.column_name);

    const result = filtredMetricIsNotAvailable(
      [state.dashboardById],
      availebleColumns,
      availebleDimensions,
    );

    return result[0];
  },
}

const mutations = {
  [EDIT_MODE](state: DashboardsState, value: boolean) {
    state.editMode = value;
  },

  [GET_DASHBOARDS_TEMPLATES](state: DashboardsState, templates: any[]) {
    state.templates = templates;
  },

  [GET_DASHBOARDS](state: DashboardsState, dashboards: GetDashboardsResponse['payload']) {
    state.dashboards = dashboards;
  },

  [GET_DASHBOARD_BY_ID](state: DashboardsState, dashboards: GetDashboardsByIdResponse['payload']) {
    state.dashboardById = dashboards;
  },

  [SET_DASHBOARD_FILTER](state: DashboardsState, filters: any) {
    state.stateDashboardFilter = filters;
  },

  [ADD_DASHBOARD_IS_LOADING](state: DashboardsState, loading: boolean) {
    state.addDashbordIsLoading = loading;
  },
} 

const actions = {
  async [GET_DASHBOARDS_TEMPLATES]({ commit }: ActionContext<DashboardsState, RootState>) {
    // if (store.getters['auth/adminAcl'].is_superuser
    //   || store.getters['auth/currentAcl'].reports_view === 'allow') {
    //   const { data: { payload } } = await this.$api.getDashboardsTemplates();
    //   commit(GET_DASHBOARDS_TEMPLATES, payload);
    // }
    commit(GET_DASHBOARDS_TEMPLATES, []);
  },

  async [GET_DASHBOARDS]({ commit }: ActionContext<DashboardsState, RootState>) {
    const params: GetDashboardsData['query']  = {
      sort_column: 'created_at',
      sort_dir: 'asc',
    };
    const api = useApi(); 
    const store = useTypedStore();

    if (
      store.getters['auth/adminAcl'].is_superuser
      || store.getters['auth/currentAcl']!.reports_view === 'allow'
    ) {
      const {
        data: { payload },
      } = await api.getDashboards(params);
      commit(GET_DASHBOARDS, payload);
    }
  },

  async [GET_DASHBOARD_BY_ID]({ commit }: ActionContext<DashboardsState, RootState>, id: string) {
    const api = useApi();
    const store = useTypedStore();

    if (
      store.getters['auth/adminAcl'].is_superuser
      || store.getters['auth/currentAcl']!.reports_view === 'allow'
    ) {
      const {
        data: { payload },
      } = await api.getDashboard(id);
      commit(GET_DASHBOARD_BY_ID, payload);
    }
  },
}

const storeModule = {
  state: stateData(),
  getters,
  mutations,
  actions,
  namespaced: true,
}

export type DashboardsModule = TypedStoreModule<'dashboards', typeof storeModule>;

export default storeModule;


